import { Routes, Route } from "react-router-dom";

import Home from "./Home";
import BackgroundRemover from "./Components/BackgroundRemover";
import VideoPlayer from "./VideoPlayer";
import FileConverter from "./Components/FileConverter";
import ScanToPdf from "./Components/ScanToPdf";
import ImageUpscaler from "./Components/ImageUpscaler";
import SignDocument from "./Components/SignDocument";
import ImageToVectorConverter from "./Components/ImageToVectorConverter";
import VectorAnimator from "./Components/VectorAnimator";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />

      <Route
        path="/iki-remove-bg"
        element={<BackgroundRemover />}
      />

      <Route
        path="/iki-file-converter"
        element={<FileConverter />}
      />

      <Route
        path="/iki-scan-to-pdf"
        element={<ScanToPdf />}
      />

      <Route
        path="/iki-image-upscaler"
        element={<ImageUpscaler />}
      />
      <Route
        path="/iki-signer-doc"
        element={<SignDocument />}
      />
      <Route
        path="/iki-image-vector-converter"
        element={<ImageToVectorConverter />}
      />

      <Route
        path="/iki-vector-animation"
        element={<VectorAnimator />}
      />

      <Route
        path="/ikiTube"
        element={<VideoPlayer />}
      />
    </Routes>
  );
}

export default App;